import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Textarea } from "./ui";

export function MarkdownEditor({
  label,
  value,
  onChange,
  hint,
}: {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  hint?: string;
}) {
  return (
    <div className="space-y-2">
      {label && <span className="block text-xs font-medium text-white/60">{label}</span>}
      {hint && <p className="text-[10px] text-white/40">{hint}</p>}
      <div className="grid gap-3 lg:grid-cols-2">
        <Textarea
          label="Markdown"
          rows={18}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="font-mono text-xs"
        />
        <div className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
          <p className="mb-2 text-[10px] font-medium uppercase tracking-wide text-white/40">Preview</p>
          <div className="legal-markdown max-h-[420px] overflow-y-auto text-sm text-white/85">
            {value.trim() ? (
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{value}</ReactMarkdown>
            ) : (
              <p className="text-xs text-white/40">Nothing to preview yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
